import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import MediaViewer from '../../../../Components/MediaViewer/MediaViewer';
import { Size } from '../../../../Enums/Size.enum';
import { EducationMaterial } from '../../../../graphql/graphql';
import { v4 } from 'uuid';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	educationMaterial: EducationMaterial;
}

const EducationMaterialViewer: React.FC<Props> = ({
	isOpen,
	onClose,
	educationMaterial,
}) => {
	const file = {
		id: v4(),
		preview: educationMaterial.value.preview,
		download: educationMaterial.link ?? educationMaterial.value.link,
		displayName: educationMaterial.name ?? '',
		type: educationMaterial.subtype ?? '',
	};

	let component = undefined;

	switch (educationMaterial.subtype) {
		case 'video':
			component = (
				<iframe
					style={{ aspectRatio: '16/9', border: 0 }}
					src={educationMaterial.value.playerLink}
					width={'100%'}
					height={'auto'}
					allow={'autoplay; fullscreen'}
					allowFullScreen
				/>
			);
			break;
		case 'pdf':
			component = <MediaViewer file={file} onSuccess={onClose} />;
			break;
	}

	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.XL}>
			<Modal.Header title='component.educationMaterialViewer.modalTitle' />
			<Modal.Content>{component}</Modal.Content>
		</Modal>
	);
};

export default EducationMaterialViewer;
